export default __webpack_public_path__ + "static/media/ic-transfer-in-transit-info-dark.b2e44582.svg";